<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Administración de Condicionados</h4>
          <hr class="horizontal dark" />
          <div class="d-flex justify-content-end">
            <a class="btn btn-addiuva-dark" @click="iniciarCrearCondicionado()">
              <i class="fas fa-plus"></i> &nbsp; Cargar Nuevo Condicionado
            </a>
          </div>
          <Toast />
          <DataTable :value="condicionados" stripedRows paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay condicionados que mostrar. </center></template>
            <Column field="id" header="ID" sortable ></Column>
            <Column field="nombre" header="Nombre" sortable ></Column>
            <Column field="data" header="Archivo" sortable >
              <template #body="{ data }">
                <a class="btn btn-link text-addiuva text-gradient px-3 mb-0" :href="prepareFile(data.archivo)" download>
                  <i class="fas fa-cloud-download-alt me-2" aria-hidden="true"></i>Descargar Condicionado
                </a>
              </template>
            </Column>
            <Column field="activo" header="Estado" sortable >
                <template #body="{ data }">
                    <Tag :value="(data.activo ? 'ACTIVO' : 'INACTIVO')" :severity="getSeverity(data.activo)" rounded/>
                </template>
            </Column>
            <Column field="company" header="Acción" style="width: 5%">
              <template #body="{ data }">
                <SplitButton label="Acciones" icon="fas fa-ellipsis-h" :model="data.items" menuButtonIcon="fas fa-ellipsis-h"  text v-if="data.items.length > 0" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <!-- Modal Dialogs -->
    <!-- Crear/Editar Condicionado -->
    <Dialog v-model:visible="editar.visible" modal header="Header" :style="{ width: '40%' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
        <div class="inline-flex align-items-center justify-content-center gap-2">
          <h5 class="text-bold white-space-nowrap text-addiuva-dark" id="title-edit">{{editar.title.toUpperCase()}}</h5>
        </div>
      </template>
      <div class="row">
        <div :class="(editar.id && typeof editar.archivo == 'string') ? 'col-md-6' : 'col-md-12'">
          <div class="row">
            <div class="col-md-10"></div>
            <div class="col-md-2 text-right" v-if="editar.id">
              <label for="editar-activo">Activo</label>
              <div class="pt-1">
                <InputSwitch v-model="editar.activo" id="editar-activo"/>
              </div>
            </div>
            <div class="col-md-12">
              <label for="nombre">Nombre Condicionado <span class="text-danger">*</span></label>
              <InputText id="nombre" class="form-control" v-model="editar.nombre"/>
            </div>
            <div class="col-md-12">
              <label for="archivo">Archivo <span class="text-danger">*</span></label>
              <input type="file" class="form-control" @change="onFileChanged"
              accept="application/pdf">

            </div>
          </div>
        </div>
        <div :class="typeof editar.archivo == 'string' ? 'col-md-6' : 'd-none'">
          <embed type="application/pdf" :src="prepareFile(editar.archivo)" v-if="editar.id" width="100%" height="400px"/>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModal()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <button class="btn btn-addiuva-dark" @click="editarCondicionado" v-if="editar.id">
          <i class="fas fa-pen pr-1"></i> Editar
        </button>
        <button class="btn btn-addiuva-dark" @click="crearCondicionado" v-if="!editar.id">
          <i class="fas fa-save pr-1"></i> Guardar
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
// import FileUpload from 'primevue/fileupload';
import axios from 'axios';
import authHeader from '../services/auth-header';

export default {
  name: "Administración de Condicionados",
  components: {
    DataTable,
    Column,
    Tag,
    Toast,
    SplitButton,
    Dialog,
    InputText,
    // FileUpload,
    InputSwitch
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      showProfileDropdown: false,
      condicionados: [],
      editar: {
        visible: false,
        title: null,
        id: null,
        nombre: null,
        archivo: null,
      },
      archivo: null,
      departamentosOptions: [],
    };
  },
  methods: {
    onFileChanged(event) {
      this.editar.archivo = event.target.files[0];
    },
    listarCondicionados() {
      this.condicionados = [];
      // Send Data by Axios
      let url = this.API_URL + "/condicionados/listar";
      axios({
        url: url,
        method: 'get',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let condicionados = [];
            data.forEach(a => {
              condicionados.push({
                id: a.id_condicionado ?? '',
                nombre: a.nombre ?? '',
                archivo: a.archivo ?? '',
                activo: a.activo ?? '',
              });
            });
            condicionados.forEach(condicionado => {
              condicionado.items = this.defineSubMenu(condicionado);
            });
            this.condicionados = condicionados;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    defineSubMenu(data) {
      let items = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        }
      ];
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == true) {
        severity = "success"
      } else {
        severity = "danger";
      }
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        title: 'Editar Condicionado',
        id: data.id,
        nombre: data.nombre,
        archivo: data.archivo,
        activo: data.activo,
      };
    },
    closeModal() {
      this.editar = {
        visible: false,
        title: null,
        id: null,
        nombre: null,
        archivo: null,
        activo: null,
      };
    },
    editarCondicionado() {
      if (this.editar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = new FormData();
      payload.append("id_condicionado", this.editar.id);
      payload.append("nombre", this.editar.nombre);
      if (typeof this.editar.archivo != "string") {
        payload.append("archivo", this.editar.archivo);
      }
      payload.append("activo", this.editar.activo);
      payload.append("_method", "PUT");
      // Send Data by Axios
      let url = this.API_URL + "/condicionados/editar";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Edición fue procesada exitosamente', life: 3000 });
            this.closeModal();
            this.listarCondicionados();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    crearCondicionado() {
      if (this.editar.id != null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error.', life: 3000 });
        return true;
      }
      let payload = new FormData();
      payload.append("nombre", this.editar.nombre);
      payload.append("archivo", this.editar.archivo);
      // Send Data by Axios
      let url = this.API_URL + "/condicionados/guardar";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'El Condicionado fue creado exitosamente!', life: 3000 });
            this.closeModal();
            this.listarCondicionados();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    iniciarCrearCondicionado() {
      this.editar = {
        visible: true,
        title: 'Cargar Nuevo Condicionado',
        id: null,
        nombre: null,
        archivo: null,
        activo: true,
      }
    },
    formatDate: function (date) {
      let aDate = date.split('/');
      return new Date(aDate[2], parseInt(aDate[1])-1, aDate[0]);
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Dashboard'});
      }
    },
    prepareFile(file) {
      let url = '#';
      if (file != '') {
        url = 'data:application/pdf;base64,' + file;
      }
      return url;
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
    this.listarCondicionados()
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>